export default __webpack_public_path__ + "static/media/sanfran.b00af96e.jpg";